import React from 'react';
import i18next from 'i18next';
import styled from 'styled-components';
import { StatusOverviewDial } from './StatusOverviewDial/StatusOverviewDial';
import { AppState } from '../../store';
import { CustomerThunkDispatch } from '../../store/customerOverview/types';
import { actionFetchKitsByStatus, actionFetchKitsOverView } from '../../store/customerOverview/action';
import { connect } from 'react-redux';
import { KitStatus } from '../../models/customerOverview';
import { Dial, KitOverviewResponse, DIALS } from '../../containers/Customers/component/Dial';

type KitStatusOverviewProps = {
  fetchKitsByStatus: (status: KitStatus, quantity?: string | number) => Promise<void>;
  fetchKitsOverView: () => Promise<void>;
  customerOverview: {
    kitStatusFilter: KitStatus | undefined;
  };
  kitOverViewResponse: KitOverviewResponse | undefined;
};

class KitStatusOverview extends React.PureComponent<KitStatusOverviewProps> {

  componentDidMount() {
    this.props.fetchKitsOverView();
  }
  selectedKitStatus = (dial: Dial) => {
    if (dial.testStatus === 'report-ready') {
      this.props.fetchKitsByStatus('report-ready', dial.quantity);
    } else if (dial.testStatus === 'report-result-ready') {
      this.props.fetchKitsByStatus('report-result-ready', dial.quantity);
    } else {
      this.props.fetchKitsByStatus(dial.kitStatus, dial.quantity);
    }
  }
  render() {
    const { kitOverViewResponse } = this.props;
    const dialList: Dial[] = DIALS
      .reduce<Dial[]>((dials, dial) => {
        const figure = dial.testStatus
          ? kitOverViewResponse && kitOverViewResponse.tests.find((overview: { status: string | undefined; }) => overview.status === dial.testStatus)
          : kitOverViewResponse && kitOverViewResponse.kit.find((overview: { status: any; }) => overview.status === dial.kitStatus);
        dials.push({
          ...dial,
          quantity: figure ? figure.count : '0',
        });
        return dials;
      }, []);
    return <RoundBorderContainer className="KitStatusOverview">
      <OverviewStatusLabel>{i18next.t('cmp.overview.title')}</OverviewStatusLabel>
      <KitStatusView>
        {
          dialList.map(dial =>
            <StatusOverviewDial
              {...dial}
              key={dial.id}
              onClick={() => this.selectedKitStatus(dial)}
            />)
        }
      </KitStatusView>
    </RoundBorderContainer>;
  }
}

const RoundBorderContainer = styled.div`
  background: white;
  border-radius: 1em;
  display: flex;
  flex-direction: column;
  padding: 0.3rem;
  .StatusOverviewDial {
    margin-left: 0rem;
  }
`;

const OverviewStatusLabel = styled.div`
  font-size:1em;
  margin-left:1em;
  margin-top:0.4em;
  font-weight: 100;
`;
const KitStatusView = styled.div`
  display: flex;
  flex-direction: row;
`;
const mapStateToProps = (state: AppState) => {
  return {
    customerOverview: state.customerOverview,
    kitOverViewResponse: state.customerOverview.kitOverViewResponse,
  };
};

const mapDispatchToProps = (dispatch: CustomerThunkDispatch) => {
  return {
    fetchKitsByStatus: (status: KitStatus, quantity?: string | number) => dispatch(actionFetchKitsByStatus(status, quantity)),
    fetchKitsOverView: () => dispatch(actionFetchKitsOverView()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(KitStatusOverview);
